export const API_CREATE_FAKE_ORDERS = "API_CREATE_FAKE_ORDERS"

export const API_GET_PARCEL_STATS = "API_GET_PARCEL_STATS"
export const API_ASK_PARCEL_RETURN = "API_ASK_PARCEL_RETURN"
export const API_DECLARE_PARCEL_RETURNED = "API_DECLARE_PARCEL_RETURNED"

export const API_CREATE_ORDER = "API_CREATE_ORDER"
export const API_UPDATE_ORDER_RECIPIENT = "API_UPDATE_ORDER_RECIPIENT"
